import { IEntity } from "@/models";

import { BaseRepository } from "@/repositories";

class EntityRepository extends BaseRepository<IEntity> {
    constructor() {
        super("/entities");
    }
}

const entityRepository = new EntityRepository();

export { EntityRepository, entityRepository };
